import AddRoleMappingDialog from './AddRoleMappingDialog';

export default AddRoleMappingDialog;
